var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeNo = function SvgVolumeNo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4328_7417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4328_7417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7984 22.6L16.7734 19.5751C16.3568 19.8417 15.9151 20.0709 15.4484 20.2626C14.9818 20.4542 14.4984 20.6084 13.9984 20.725V18.675C14.2318 18.5917 14.4609 18.5084 14.6859 18.425C14.9109 18.3417 15.1234 18.2417 15.3234 18.1251L11.9984 14.8V20L6.99844 15H2.99844V9.00005H6.19844L1.39844 4.20005L2.79844 2.80005L21.1984 21.2001L19.7984 22.6ZM19.5984 16.8L18.1484 15.35C18.4318 14.8334 18.6443 14.2917 18.7859 13.725C18.9276 13.1584 18.9984 12.5751 18.9984 11.975C18.9984 10.4084 18.5401 9.00838 17.6234 7.77505C16.7068 6.54172 15.4984 5.70838 13.9984 5.27505V3.22505C16.0651 3.69172 17.7484 4.73755 19.0484 6.36255C20.3484 7.98755 20.9984 9.85838 20.9984 11.975C20.9984 12.8584 20.8776 13.7084 20.6359 14.5251C20.3943 15.3417 20.0484 16.1 19.5984 16.8ZM16.2484 13.45L13.9984 11.2V7.95005C14.7818 8.31672 15.3943 8.86672 15.8359 9.60005C16.2776 10.3334 16.4984 11.1334 16.4984 12C16.4984 12.25 16.4776 12.4959 16.4359 12.7375C16.3943 12.9792 16.3318 13.2167 16.2484 13.45ZM11.9984 9.20005L9.39844 6.60005L11.9984 4.00005V9.20005Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeNo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/volume-no.1fc23bbb5e03dc527a23824424ef7ce3.svg";